import { SubscriptionScreen } from '~/purchases/components/subscription-screen/SubscriptionScreen';

// Lives at the `(private)` stack level (not inside `(tabs)`/`(sidebar)`) so it is
// reachable from anywhere on every platform — a hidden tab route is not navigable
// under the iOS native tab bar. SidebarLayout still wraps it, so the web sidebar
// stays visible; on mobile it presents as a full-screen route with its own close.
export default SubscriptionScreen;
